import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-factory",
  "use": "icon-factory-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-factory\">\r\n<path d=\"M58.9,90.4L32.2,69.9L34.3,11h21.4C55.7,11,58.9,90.4,58.9,90.4z M111.4,11H90l-2.1,58.9l26.8,20.5\r\n\tC114.6,90.4,111.4,11,111.4,11z M167.1,11h-21.4l-2.1,58.9l26.8,20.5C170.3,90.4,167.1,11,167.1,11z M124.3,69v42.7L68.6,69v42.2\r\n\tL13.6,69v120h175v-70.7L124.3,69z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/factory.svg
// module id = 7QiR
// module chunks = 87